import React, {ReactElement} from "react"

const EditIcon = (): ReactElement => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1 13.0001V17.0001L5 17.0001L15.8686 6.13146L15.8695 6.13061C16.265 5.73516 16.4628 5.53736 16.5369 5.3092C16.6021 5.10835 16.6022 4.89201 16.5369 4.69117C16.4627 4.46284 16.2646 4.26474 15.8686 3.86872L14.1288 2.12892C13.7345 1.7346 13.5369 1.53704 13.3091 1.46301C13.1082 1.39775 12.8919 1.39775 12.691 1.46301C12.463 1.53709 12.2652 1.73488 11.8704 2.12976L11.8686 2.13146L1 13.0001Z"
	      stroke="#7E8591"
	      strokeWidth="1.5"
	      strokeLinecap="round"
	      strokeLinejoin="round"
			/>
		</svg>
	)
}

export default EditIcon
